import type {PS} from '@wix/document-services-types'

const afterAddPage = (ps: PS, compPointer) => {
    ps.extensionAPI.sectionOrderAPI?.orderSections(compPointer)
}

export default {
    afterAddPage
}
